import { RangePickerValue } from "antd/lib/date-picker/interface";
import moment from "moment";

export function getRangePickerValue(first: Date | undefined, second: Date | undefined): RangePickerValue {
  const firstUndefined = first === undefined;
  const secondUndefined = second === undefined;

  if (!firstUndefined && !secondUndefined) {
    return [moment(first!), moment(second!)];
  }

  if (!firstUndefined && secondUndefined) {
    return [moment(first!)];
  }

  if (firstUndefined && !secondUndefined) {
    return [undefined, moment(second!)];
  }

  return [];
}
